/**
 * 3-bar audio visualizer — Preact port of the legacy
 * `createSoundBars` factory. Static when idle, CSS-keyframe animated
 * when `recording`. Used by the video greeter Talk-Now overlay and
 * the footer audio-input button.
 */

export interface SoundBarsProps {
  recording: boolean;
  height?: string;
  barWidth?: string;
  gap?: string;
}

export function SoundBars({
  recording,
  height = '20px',
  barWidth = '3px',
  gap = '3px',
}: SoundBarsProps) {
  const cls = recording ? 'sp-sound-bars--animated' : 'sp-sound-bars--static';
  return (
    <div class={`sp-sound-bars ${cls}`} style={{ height, gap }}>
      <div class="sp-sound-bar sp-sound-bar--1" style={{ width: barWidth }} />
      <div class="sp-sound-bar sp-sound-bar--2" style={{ width: barWidth }} />
      <div class="sp-sound-bar sp-sound-bar--3" style={{ width: barWidth }} />
    </div>
  );
}
